import { ChangeDetectorRef, Component, Input, OnInit,OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DataConnectorType, ExcelDataConnector, FtpServerType, FtpService } from 'src/app/domainObjects/dataConnector';
import { DataSourceType } from 'src/app/domainObjects/dataSourceType';
import { IngestConfigViewModel } from 'src/app/views/import-data/import-data.component';
import { ConfigService } from 'src/app/services/config/config.service';
import { FileBrowserDialogComponent } from 'src/app/views/file-browser-dialog/file-browser-dialog.component';
import { DataConnectorViewModel } from 'src/app/viewModels/dataConnectorViewModel';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { BaseComponent } from '../../../../base/base.component';
import { ErrorReportingService } from '../../../../services/errorReporting/error-reporting.service';
// import { IngestParametersSetting } from 'src/app/domainObjects/masterConfig';
import { UserDataService } from 'src/app/services/user-data-service';
import { FolderBrowserDialogComponent } from 'src/app/views/folder-browser-dialog/folder-browser-dialog.component';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { UpdateingestnodestatusService } from 'src/app/services/updateingestnodestatus.service';
import { GetExcelSheetNamesRequest } from 'src/app/messaging/getExcelSheetNamesRequest';
import { FtpConnectionStatus, ftpNotReadyMessage } from 'src/app/views/shared/ftp-service-select/ftp-service-select.component';


export class ExcelDataConnectorViewModel extends DataConnectorViewModel<ExcelDataConnector> {
  id: number;
  inputFileNameExcel = '';
  inputFileNameExcelScheduleDirectory='';
  scheduleConnectionTimeOut='';
  connectionTimeOut=0;
  fileNameFormatExcel = '';
  baseFileName='';
  sheetName = '';
  scheduleSheetName = '';
  sheets: string[];
  //selectedInstance='';  // Default value
  selectedInstance= '';
  nValue= '';
  dateTimeExtension: string = '';  // Date-Time extension
  currentDate: string;  // Holds the current date in YYYY-MM-DD format
  fileExtension='';
  isMultiTabIngest: boolean;
  excelTurboMode: boolean;
  
  constructor(dataConnector?: ExcelDataConnector) {
    super();
    this.dataConnectorType = DataConnectorType.Excel;
    // Set current date in YYYY-MM-DD format
    const today = new Date();
    this.currentDate = today.toISOString().split('T')[0]; // Extracts the date part in YYYY-MM-DD format
    this.isUseFtp =false;
    this.ftpService = new FtpService(FtpServerType.SFTP,"","","", 22);

    if (dataConnector) {
      this.inputFileNameExcel = dataConnector.filePath;
      this. inputFileNameExcelScheduleDirectory="";
    
      this.baseFileName='';
      this.scheduleSheetName="";
      this.fileNameFormatExcel = dataConnector.fileNameFormat;
      this.sheetName = dataConnector.sheetName;
      this.sheets = dataConnector.sheets;
      this.id = dataConnector.id;
      this.connectionTimeOut = dataConnector.connectionTimeOut;
      this.selectedInstance=dataConnector.selectedInstance;
      this.nValue=dataConnector.nValue;
      this.isUseFtp = dataConnector.isUseFtp;
      this.ftpService = dataConnector.ftpService;
    }
    this.scheduleConnectionTimeOut="180"
    this.dateTimeExtension = 'yyyy-MM-dd';  // Set the current date as default
    this.fileExtension='.xlsx';
  }

  toDataConnector(): ExcelDataConnector {
    return new ExcelDataConnector(this.id, this.inputFileNameExcel, this.fileNameFormatExcel, this.sheetName, this.sheets, this.connectionTimeOut,this.selectedInstance,this.nValue,this.isUseFtp,this.ftpService);
  }
}


@Component({
    selector: 'app-excel-data-connector',
    templateUrl: './excel-data-connector.component.html',
    styleUrls: ['./excel-data-connector.component.css'],
    standalone: false
})
export class ExcelDataConnectorComponent extends BaseComponent implements OnInit {
  @Input() dataSourceType: DataSourceType;
  @Input() dataTransformConfigViewModel: DataTransformConfigViewModel;
  @Input() ingestConfigViewModel: IngestConfigViewModel;
  //@Input() isMultiTabIngest: boolean;
  //@Input() viewModel: FileDataConnectorViewModel;
  isDisabled: boolean;
  viewModel: ExcelDataConnectorViewModel;
  form: FormGroup;
  formGroup : { [key: string]: any } = {};
  formattedDate: string;
  selectedFormat: string = 'yyyy-MM-dd'; // Default format
  isInstanceDisabled:boolean;
  constructor(
    errorLogger: ErrorReportingService,
    matDialog: MatDialog,
    private changeDet: ChangeDetectorRef,
    private userData: UserDataService,
    private formBuilder: FormBuilder,
    public datePipe: DatePipe,
    private updateingestnodestatusService: UpdateingestnodestatusService,
    private configService: ConfigService) {
      super(errorLogger, matDialog);
      this.updateDate();
      //this.isDisabled = this.viewModel.isMultiTabIngest;
      this.isDisabled = false;
     this.isInstanceDisabled= false;
     
      
     }
    
    //  filePath:IngestParametersSetting;
    //  tabName:IngestParametersSetting;
    //  connectionTimeOut:IngestParametersSetting;
    //  schedulerHeading:IngestParametersSetting;
    //  schedulerDirectory:IngestParametersSetting;
     updateDate() {
      const currentDate = new Date();
      this.formattedDate = this.datePipe.transform(currentDate, this.selectedFormat) || '';
    }
   // Call this method when format changes
  onFormatChange(newFormat: string) {
    this.selectedFormat = newFormat;
    this.updateDate();
  }
  savedIngestConfig:any;
  ngOnInit(): void {

    console.log("excel data isMultiTabIngest=", this.viewModel.isMultiTabIngest);
    console.log("excel data connector model", this.viewModel.sheets);
    console.log("excel ingestConfigViewModel", this.ingestConfigViewModel);

    const configJsonObject = this.userData.getSelectedConfigJson(); //state.config;
    if(configJsonObject){
      this.savedIngestConfig = configJsonObject.dataConnectorMappings.filter( item => item.guid === this.ingestConfigViewModel?.guid)[0];
    }

    // this.ingestConfigViewModel.dataConnector = this.viewModel;

   // const selectedNode=this.userData.getSelectedNodeDetails();
   // console.log("selectedNode prajna====",selectedNode);

   // const connectorTypeData=this.userData.getIngestConnectorData()
   // console.log("connectorTypeData prajna====",connectorTypeData); 
   // const masterconfig=this.userData.getIngestConnectorData().find(x=>x.id==1);
   // console.log("masterconfig prajna====",masterconfig);
    //var params=masterconfig.parameters;
    //console.log("params prajna====",params);
  
    //var params=masterconfig.parameters.find(x=>x.connectortypeid==2).parameters;


   // timeextensionvalue=this.datePipe.transform(currentDate, timeextension.value);

   // this.filePath=params.find(x=>x.jsonobject=='filePath');
    //this.tabName=params.find(x=>x.jsonobject=='tabName');
   // this.schedulerHeading=params.find(x=>x.jsonobject=='schedulerHeading');
  //  this.schedulerHeading=params.find(x=>x.jsonobject=='schedulerHeading');
   // this.schedulerDirectory=params.find(x=>x.jsonobject=='schedulerDirectory');
    //this.connectionTimeOut=params.find(x=>x.jsonobject=='timeout');
    // Set the current date in YYYY-MM-DD format
   // const today = new Date();
   // this.viewModel.dateTimeExtension = today.toISOString().split('T')[0]; // Set default value
    //this.viewModel = this.ingestConfigViewModel.fileDataConnector;
    //this.importSetupViewModel.fileDataConnectorViewModel = this.viewModel;
    if(!this.viewModel.ftpService){
      this.viewModel.ftpService=new FtpService(FtpServerType.SFTP,"","","", 22);
    }
  }
  
  ngOnChanges(changes: any) {
    this.viewModel = changes.ingestConfigViewModel?.currentValue.getExcelDataConnector();
    if (!this.viewModel) {
      this.viewModel = new ExcelDataConnectorViewModel();
      this.viewModel.ftpService=new FtpService(FtpServerType.SFTP,"","","", 22);
      this.viewModel.dataSourceType = this.dataSourceType;
      this.ingestConfigViewModel.dataConnector = this.viewModel;
    }
    //this.checkDisabledState();
    /*if (!this.viewModel || this.viewModel.dataConnectorType!=DataConnectorType.Excel) {
      //console.log('creating new ExcelDataConnectorViewModel...');
      this.viewModel = new ExcelDataConnectorViewModel();
      this.viewModel.dataSourceType = this.dataSourceType;
      this.ingestConfigViewModel.dataConnector = this.viewModel;
    } else {
      //console.log(`Existing excelDataConnectorViewModel is used: ${this.viewModel}`);
    }*/
  }

  /** Connection test state of the selected FTP service; FTP browsing waits for 'success'. */
  ftpConnectionStatus: FtpConnectionStatus = 'none';

  onFtpChange(updated: FtpService) {
    this.viewModel.ftpService = updated;
  }

  checkDisabledState() {
    console.log("ck disable status", this.viewModel);
    console.log("ck savedIngestConfig", this.savedIngestConfig);
    console.log("ck ingestConfigViewModel", this.ingestConfigViewModel);
    if (this.isDisabled) {
      // this.viewModel.sheets = 'Multi-tab'; // Set default value for disabled state
      this.viewModel.isMultiTabIngest = true; // Set default value for disabled state
      this.viewModel.sheetName = 'Multi-tab'; // Set default value for disabled state
      this.viewModel.scheduleSheetName = 'Multi-tab'; // Set default value for disabled state
      this.changeDet.detectChanges();
    } else {
      // Keep the behavior the same as the previous checkDisabledState() implementation
      // Add the previous implementation logic here if necessary
      this.viewModel.scheduleSheetName = this.savedIngestConfig?.dataConnector?.scheduleSheetName;
      this.viewModel.isMultiTabIngest = false;
      var sheetName = this.savedIngestConfig.dataConnector.sheetName
      if (sheetName === '' || sheetName === 'Multi-tab') {
        this.viewModel.sheetName = this.savedIngestConfig.dataConnector.sheets[0];
      } else {
        this.viewModel.sheetName = this.savedIngestConfig.dataConnector.sheetName
      }
      
     
    }
  }
 

  async handleBlur(value: string) {
    if(value){
      console.log('Input field lost focus. Current value:', value);
      await this.getSheetDetails(value);
    }
  }
  handleBlurDirectory(inputFileNameExcel: string) {
    setTimeout(() => {
      // Your logic to handle the blur event
      console.log('Directory:', inputFileNameExcel);
    }, 200);
  }

  showFileBrowserDialog(): void {
    const ftpNotReady = ftpNotReadyMessage(this.viewModel.isUseFtp, this.ftpConnectionStatus);
    if (ftpNotReady) {
      this.displayError(ftpNotReady, 'FTP Service');
      return;
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '750px';
    this.viewModel.dataConnectorType = (this.viewModel.dataConnectorType !== 4) ? DataConnectorType.Excel : this.viewModel.dataConnectorType;
    dialogConfig.data = {dataSourceTypeId: this.dataSourceType, supportedFileTypes: ['.xls*', '.xlsx', '.xls'],isUseFtp:this.viewModel.isUseFtp,ftpService:this.viewModel.ftpService, ingestFilePath:this.viewModel.inputFileNameExcel, ingestDataConnectorType: this.viewModel.dataConnectorType};

    const dialogRef = this.matDialog.open(FileBrowserDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(async result => {
      if (!result.selectedFileName) { return; }

      // File chosen is
      console.log('User selected to import file prajna: ' + result.selectedFileName);
      // this.viewModel.inputFileNameExcel = result.selectedFileName;

      // TODO: Determine why I need to invoke the below code to get UI reflecting the inputFileName
      this.changeDet.detectChanges();

      const busyDialog = this.showBusyDialog('Please wait...');

      try {
        await this.getSheetDetails(result.selectedFileName);
      } catch (error) {
        this.displayError('Failed to get excel sheet names', 'Error', error);
      }
      finally {
        busyDialog.close();
      }
    });
  }

  async getSheetDetails(filePath: string){
    const busyDialog = this.showBusyDialog('Getting Sheet Name...');
    try {
      // Get sheet names
      this.viewModel.inputFileNameExcel = filePath;
      let getExcelSheetNamesRequest = new GetExcelSheetNamesRequest(this.viewModel.inputFileNameExcel, this.viewModel.isUseFtp, this.viewModel.ftpService)
      const sheets = await this.configService.getExcelSheetNames(getExcelSheetNamesRequest);
      this.viewModel.sheets = sheets;

      // default the sheet if we have one
      // if (!this.viewModel.sheetName && sheets.length > 0) {
      if (!this.viewModel.sheetName || sheets.length > 0) {
          this.viewModel.sheetName = sheets[0];
        
        // TODO: Determine why I need to invoke the below code to get UI reflecting the inputFileName
        this.changeDet.detectChanges();
  
      }
    }
    catch (err) {

      const errorMessage = err?.error || err?.message || '';
      const statusCode = err?.status;

      if (statusCode === 500 || errorMessage.includes('500 Internal Server Error')) {
        this.displayError("The file or file path of the Developer File Path was not found or incorrectly entered.", "File or File path not found");    
        this.viewModel.inputFileNameExcel = "" ;
        this.changeDet.detectChanges();
       
      } else {
        this.displayError('Failed to get Sheet Name', 'Error', err, (result) => {});
      }
     
      this.changeDet.detectChanges();
     
    } finally {
      this.updateingestnodestatusService.invokeUpdateIngestNodeStatus();
      busyDialog.close();
    }   

        //console.log(sheets);
  }
  onSelectionChange(selectedValue: string) {
    if (selectedValue === 'first') {
      this.viewModel.nValue = '1';
      this.isInstanceDisabled = true;  // Freeze the instance field
    } else if (selectedValue === 'nth') {
      this.viewModel.nValue = '1'; // Keep it blank for nth
      this.isInstanceDisabled = false;  // Freeze the instance field
    } else {
      this.viewModel.nValue = ''; // Keep it blank for nth
      this.isInstanceDisabled = true;  // Freeze the instance field
    }
  }
  browseDir(){
    //console.log("browseDir....",fieldname);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '750px';
    dialogConfig.data = {dataSourceTypeId: 1, supportedFileTypes: ['.csv', '.txt']};

    const dialogRef = this.matDialog.open(FolderBrowserDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result.selectedFileName) { return; }

      // File chosen is
      //console.log('User selected to import file: ' + result.selectedFileName);
      this.viewModel.inputFileNameExcelScheduleDirectory = result.selectedFileName;
       // Focus back to the input field if necessary
     // Focus back to the input field if necessary

    //  this.formGroup[fieldname] = new FormControl(result.selectedFileName);
      //this.form = this.formBuilder.group(this.formGroup);
       // Ensure the input field regains focus
        this.changeDet.detectChanges();
    });
  }
  toggleChange(value:boolean){
    this.isDisabled=value;
    console.log("toggle change multi tab value==",this.isDisabled);
    this.checkDisabledState();
  }
}
